import { API } from 'aws-amplify';

const API_NAME = 'stripe';

async function cancel(promise) {
  API.cancel(promise);
}

function confirmCheckoutSession(payload) {
  return API.post(API_NAME, '/stripe/checkout/confirm', {
    body: payload,
  });
}

function createCheckoutSession(payload) {
  return API.post(API_NAME, '/stripe/checkout/create', {
    body: payload,
  });
}

export {
  cancel,
  confirmCheckoutSession,
  createCheckoutSession,
};
